/**
 * Formatting helper functions for input fields
 */

/**
 * Format number to 2 decimal places
 * @param {number} value - The value to format
 * @returns {string} - Formatted string with 2 decimal places
 */
export const formatNumber = (value) => {
  if (typeof value === 'number' && !isNaN(value)) {
    return value.toFixed(2)
  }
  return ''
}

/**
 * Format percentage with smart decimal display
 * - Shows no decimals for whole numbers (e.g., "5%")
 * - Shows 2 decimals for fractional numbers (e.g., "4.73%")
 * @param {number} value - The percentage value to format
 * @returns {string} - Formatted percentage string
 */
export const formatPercentage = (value) => {
  if (typeof value === 'number' && !isNaN(value)) {
    const isWholeNumber = Math.abs(value - Math.round(value)) < 0.01
    if (isWholeNumber) {
      return `${Math.round(value)}%`
    } else {
      return `${value.toFixed(2)}%`
    }
  }
  return ''
}

/**
 * Convert string values to numbers safely
 * @param {string|number} value - The value to convert
 * @param {number} fallback - Fallback value if conversion fails
 * @returns {number} - Converted numeric value
 */
export const safeParseNumber = (value, fallback = 0) => {
  if (typeof value === 'string') {
    const parsed = parseFloat(value)
    return isNaN(parsed) ? fallback : parsed
  }
  return typeof value === 'number' && !isNaN(value) ? value : fallback
}
